var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatOptions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 16,
    viewBox: "0 0 2 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    rx: 1,
    fill: "#778797"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#778797"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#778797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatOptions);
export default __webpack_public_path__ + "static/media/chat_options.71d9da53549cdeb918f12c63e85c0fa1.svg";
export { ForwardRef as ReactComponent };